import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Redirect to static index.html
    window.location.href = '/index.html';
  }, []);

  return (
    <div className="loading-redirect" style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: '#050505',
      color: '#F5F5F0'
    }}>
      <p>Loading Darren Warren...</p>
    </div>
  );
}

export default App;
